// extracted by mini-css-extract-plugin
export default {"container":"YJYcEB","header":"fdj4PF","footer":"HNEx2N"};